/**
 * Returns true if the device is a touchscreen
 *
 * @returns true if the device is a touchscreen, false otherwise
 */
export const isTouchscreen = () => {
  return window.matchMedia("(pointer: coarse)").matches;
};
